import { useCampaignPopup } from 'features/add-campaign/form/useCampaignPopup';
import { usePopup } from 'hooks/usePopup';

import SuccessPopup from './SuccessPopup';

export const useSuccessPopup = () => {
  const { showPopup } = usePopup();
  const { showAddCampaignPopup } = useCampaignPopup();

  const showSuccessPopup = () => {
    showPopup(<SuccessPopup onCreateCampaign={showAddCampaignPopup} />);
  };

  return { showSuccessPopup };
};
